import * as actionType from './ActionType';

export const setOnboardResult = (data) => ({
  type: actionType.SET_ONBOARD_RESULT,
  payload: data
});
